import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cc384fd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1cc384fd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc384fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cc384fd')) {
      api.createRecord('1cc384fd', component.options)
    } else {
      api.reload('1cc384fd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cc384fd&scoped=true", function () {
      api.rerender('1cc384fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/investment-advisor/index.vue"
export default component.exports